
<template>
	<div 
		:id="id"
		v-show="isCmeRegModalVisible" 
		class="cmereg-modal modal fixed inset-0 text-sm"
		:on-click="hideCmeRegModal"
	>
		<section class="absolute inset-0 bg-bg-002 opacity-30"></section>
		<div class="modal-close flex flex-row fixed top-12 left-1/2 justify-end w-11/12 md:w-10/12 px-5 transform -translate-x-1/2 pointer-events-none">
			<UiButton
				class="pointer-events-auto"
				type="icon"
				name="close"
				:on-click="hideCmeRegModal"
			/>
		</div>
		<section class="hide-scrollbar w-full h-full max-h-full relative overflow-auto" @click="hideCmeRegModal">
			<article class="modal-content w-11/12 md:w-10/12 m-auto bg-bg-001 my-8 p-5 shadow-default pointer-events-auto" @click.stop="">
				<header class="my-12">
					<div class="logo m-auto"><UiLogo/></div>
				</header>
				<section class="grid grid-cols-1 gird-rows-auto gap-5">
					<p><strong>To claim credit, you must be an @Point of Care registered user.</strong></p>
					<p><strong>Please perform the following:</strong></p>
					<ol class="instructions">
						<li class="flex flex-row flex-nowrap">
							<span class="red-circle">1</span>
							<span>Click on continue button to login and/or register on <strong>@Point of Care</strong> and return to story.</span>
						</li>
						<li class="flex flex-row flex-nowrap">
							<span class="red-circle">2</span>
							<span>Click Claim Credit.</span>
						</li>
					</ol>
				</section>
				<footer class="flex flex-row justify-center mt-8">
					<UiButton
						class="mx-auto"
						label="Continue"
						:on-click="userLogin"
					/>
				</footer>
			</article>
		</section>
	</div>
</template>

<script>
import globalMixins from '@/mixins/global-mixins'

import UiLogo from '@/components/ui/Logo'
import UiButton from '@/components/ui/Button'

/* eslint-disable no-console */
export default {
	name: 'CmeRegModal',
	components: {
		UiLogo,
		UiButton,
	},
	mixins: [
		globalMixins
	],
	props: {
		id: {
			type: String,
			default: 'cmeRegModal'
		},
	}
}
</script>

<style src="@/assets/css/tailwind.css"></style>
<style src="@/assets/css/_config.css"></style>
<style src="@/assets/css/_global.css"></style>
<style src="@/assets/css/animations.css"></style>
<style src="@/assets/css/main.css"></style>

<style scoped>
.cmereg-modal { z-index: 998; }
.modal-close { z-index: 997; }

.modal-close,
.modal-content { max-width: 600px !important; }

/* .logo { width: 70%; max-width: 320px; } */
.logo { width: 70%; max-width: 230px; }

.red-circle {
	float: left;
	display: block;
	margin-top: -0.25rem;
	margin-right: 0.6em;
	width: 24px;
	min-width: 24px;
	max-width: 24px;
	height: 24px;
	min-height: 24px;
	max-height: 24px;
	line-height: 24px;
	text-align: center;
	font-size: 0.8em;
	background: #cc2036;
	color: #fff;
	border-radius: 50%;
}
</style>